module.exports = __webpack_public_path__ + "static/media/logos-new.fccca385.png";